interface ParagraphTextProps {
  children: React.ReactNode;
  additionalClasses?: string;
}

function ParagraphText({ additionalClasses, children }: ParagraphTextProps) {
  return (
    <div
      className={`font-normal text-[16px] leading-[28px] ${additionalClasses}`}
    >
      {children}
    </div>
  );
}

export default ParagraphText;
